module.exports = __webpack_public_path__ + "static/media/preview_screen1.345352ae.png";